//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import ClockInDetail from "./ClockInDetail.vue";
export default {
  components: {
    ClockInDetail,
  },
  data() {
    return {
      activeName: "first",
      activeNameT: "first",
      activeNameC: "first",
      landInfo: {}, // 地块切卡的地块信息（地图右侧信息）
      workInfo: {}, // 地块切卡的作业信息（地图右侧信息）
      auditInfo: [], // 地块切卡的审核信息（地图右侧信息）
      previewSrc: "",
      previewSrcList: [],
      trajectoryInfo: {}, //轨迹的信息（地图右侧信息）
      trajectoryBlockInfo: [], //轨迹的地块信息（地图右侧信息）
      assignDetail: {}, // 派活信息（地图右侧信息）
    };
  },
  props: {
    // 是否显示右侧信息
    showRightInfo: {
      type: Boolean,
    },
    // 是否显示地块的信息
    showLandDetail: {
      type: Boolean,
    },
    // 是否显示轨迹的信息
    showTrajectoryDetail: {
      type: Boolean,
    },
    // 是否显示派活的信息
    showAssignDetail: {
      type: Boolean,
    },
    // 是否显示打卡的信息
    showAssignClockInDetail: {
      type: Boolean,
    },
    // 点击某块的数据
    curPolygonVal: {
      type: Object,
    },
    // 点击某marker的数据
    curMarkerVal: {
      type: Object,
    },
    hasMapBottomInfo: {
      type: Boolean,
    },
    // 右侧信息配置项
    mapRightInfoOptions: {
      type: Object,
      default: function () {
        return {
          landInfoType: "vertical", //地块信息样式：vertical 纵向即一行一列，Horizontal横向即一行多列
          hasLandInfoForLandDetail: true, // 地块信息面板是否有地块信息切卡
          hasWorkInfoForLandDetail: true, // 地块信息面板是否有作业信息切卡
          hasAuditInfoForLandDetail: true, // 地块信息面板是否有审核信息切卡
          hasTrajectoryPlayBtn: true, // 是否有轨迹回放按钮
        };
      },
    },
  },
  watch: {
    curPolygonVal(n) {
      if (this.showLandDetail) {
        this.landInfo = {};
        this.workInfo = {};
        let { landId, workLandId } = n;
        this.$http.work.getLandDetail({ id: landId }).then((res) => {
          this.landInfo = res.data;
        });
        if (workLandId) {
          this.$http.work.getWorkLandDetails({ workLandId }).then((res) => {
            this.workInfo = res.data;
          });
        }
      }
      if (this.showTrajectoryDetail) {
        let { id } = n;
        this.$http.work.getLandTrajectoryInfo({ workId: id }).then((res) => {
          this.trajectoryInfo = res.data;
          this.trajectoryInfo.workId = id;
        });
        this.$http.work
          .getTrajectoryLandInfo({ trajectoryId: id })
          .then((res) => {
            this.trajectoryBlockInfo = res.data;
          });
      }
    },
  },
  created() {
    this.$bus.$on("getAssignDetail", this.getAssignDetail);
  },
  destroyed() {
    this.$bus.$off("getAssignDetail");
  },
  methods: {
    ...mapActions("map", ["changeTrajectoryPlay"]),

    /**
     * @descripttion: 触发父组件切换展示地图右侧信息
     * @Author: juanjuanhui
     * @Date: 2021-12-02 20:30:37
     * @param {*}
     * @return {*}
     */
    handleChangeRightInfo() {
      this.$bus.$emit("changeRightInfo", { show: false });
    },
    /**
     * @descripttion: 获取派活信息（地图右侧信息）
     * @Author: juanjuanhui
     * @Date: 2021-12-02 19:57:06
     * @param {*}
     */
    getAssignDetail(params) {
      this.$http.work.getAssignDetails(params).then((res) => {
        this.assignDetail = res.data;
      });
    },
    /**
     * @descripttion: 轨迹播放
     * @Author: juanjuanhui
     * @Date: 2021-12-13 11:47:27
     * @param {*} workId
     */
    handleTrajectoryPlay(workId) {
      this.changeTrajectoryPlay({ show: true, workId });
    },
    /**
     * @descripttion: 预览图片
     * @Author: juanjuanhui
     * @Date: 2021-12-16 18:55:09
     */
    handlePreviewImg(data) {
      this.previewSrcList = data;
      this.$refs.previewImg.showViewer = true;
    },
  },
};
